import { ComponentSettings, empty } from "../settings/settings";

const settings = {
  permission: {},
  text: {},
  url: {},
  list: {
    featureFields: empty,
  },
  field: {},
  additionalInfo: {},
};

export const threadItem: ComponentSettings<typeof settings> = settings;
